import { ConfigurationFilterType, IConfigurationFilter, ISelectableFilter } from '../../api/reports.dao';
import { getScheduledEmailDateString, getScheduledEmailTimeString } from './date.util';

export const getReportFilterText = (currentFilterConfiguration: ISelectableFilter, filter: IConfigurationFilter, timeZone?: string) => {
    if (currentFilterConfiguration.type === ConfigurationFilterType.CHECKBOX) {
        const currentFilterValues = currentFilterConfiguration.items.filter(el => filter.values.includes(el.value));
        const currentFilterValuesText = currentFilterValues.map(el => el.label || el.value).join(', ');
        return currentFilterValuesText;
    }
    if (currentFilterConfiguration.type === ConfigurationFilterType.SEARCH) {
        return filter.values.join(', ');
    }
    if (currentFilterConfiguration.type === ConfigurationFilterType.NUMBER) {
        return `${filter.values[0]} ${currentFilterConfiguration.additionalLabel || ''}`;
    }
    if (currentFilterConfiguration.type === ConfigurationFilterType.DATE_TIME && timeZone) {
        const date = new Date(filter.values[0]);
        const timeString = getScheduledEmailTimeString(date, timeZone);
        const dateString = getScheduledEmailDateString(date, timeZone);

        return `${dateString} ${timeString}`;
    }
};
